class DiscountCodeBlock extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-action="apply-discount"]');
    this.buttonText = this.querySelector('.discount-code-block__button-text');
    this.originalButtonText = this.buttonText ? this.buttonText.textContent : '';
    this.discountCode = this.dataset.discountCode;
    this.copyIcon = this.querySelector('.discount-code-block__icon--copy');
    this.checkIcon = this.querySelector('.discount-code-block__icon--check');

    if (this.button) {
      this.button.addEventListener('click', this.handleApplyDiscount.bind(this));
    }
  }

  async handleApplyDiscount(e) {
    e.preventDefault();

    if (!this.discountCode) {
      return;
    }

    this.button.disabled = true;

    try {
      await this.copyToClipboard(this.discountCode);

      this.showCopiedState();
      this.updateButtonText('Code promo appliqué');

      await this.applyDiscountCode(this.discountCode);

      setTimeout(() => {
        this.button.disabled = false;
      }, 2000);

    } catch (error) {
      console.error('Error applying discount:', error);
      this.button.disabled = false;
      this.resetCopiedState();
    }
  }

  async copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        textArea.remove();
      } catch (error) {
        console.error('Fallback: Could not copy text', error);
        textArea.remove();
        throw error;
      }
    }
  }

  async applyDiscountCode(code) {
    try {
      const response = await fetch(`/discount/${code}`);

      if (!response.ok) {
        console.warn('Discount fetch returned non-OK status');
      }

      return response;
    } catch (error) {
      console.error('Error fetching discount:', error);
      throw error;
    }
  }

  showCopiedState() {
    this.button.classList.add('copied');
    this.copyIcon.classList.add('hidden');
    this.checkIcon.classList.remove('hidden');
  }

  resetCopiedState() {
    this.button.classList.remove('copied');
    this.copyIcon.classList.remove('hidden');
    this.checkIcon.classList.add('hidden');
    this.updateButtonText(this.originalButtonText);
  }

  updateButtonText(text) {
    if (this.buttonText) {
      this.buttonText.textContent = text;
    }
  }
}

customElements.define('discount-code-block', DiscountCodeBlock);
